import ConfigurazioniPage from "./pages/ConfigurazioniPage.vue";
import ConfigurazioniMagazzinoPage from "./pages/ConfigurazioniMagazzinoPage.vue";

export default {
	ConfigurazioniPage,
	ConfigurazioniMagazzinoPage,
};
